import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaPen } from 'react-icons/fa';
import './CreatePostFAB.scss';

interface CreatePostFABProps {
  /** Pass the owner's on-chain profile ID when on own profile page, enables PPV posts */
  profileId?: number;
}

const CreatePostFAB: React.FC<CreatePostFABProps> = ({ profileId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Portal to body so the fixed positioning is always viewport-relative —
  // an ancestor with transform/backdrop-filter would otherwise turn the
  // FAB's "right: 2rem" into "2rem from a wider parent," pushing it off-screen.
  return ReactDOM.createPortal(
    <button
      className="create-post-fab"
      onClick={() => navigate('/create-post', { state: { from: location.pathname, profileId } })}
      title="Create post"
      aria-label="Create post"
    >
      <FaPen />
    </button>,
    document.body
  );
};

export default CreatePostFAB;
